<div class="input-submittals">
  <procure-expansion-panel
    flat
    [label]="label()"
  >
    @if (hint()) {
      <div formRow>
        <procure-hint class="input-submittals__hint">
          {{ hint() }}
        </procure-hint>
      </div>
    }
    <div formRow>
      @if (isCheckedControls.length) {
        <ol class="input-submittals__options">
          @for (value of isCheckedControls; track $index; let i = $index) {
            <li class="input-submittals__item">
              <div class="input-submittals__value">
                <procure-input-check
                  class="input-submittals__check"
                  [control]="isCheckedControls[i]"
                  [showMode]="showMode()"
                  [tooltip]="tooltips()[i] || ''"
                >
                  <span
                    [class.input-submittals__value--disabled]="
                      isCheckedControls[i].disabled && showMode() && limitIndices()?.length
                    "
                  >
                    {{ nameControls[i].value }}
                  </span>
                </procure-input-check>
              </div>
              @if (isCheckedControls[i].value) {
                <div class="input-submittals__description">
                  <procure-input-textarea
                    [label]="additionalLabel()"
                    [control]="commentControls[i]"
                    [showMode]="showMode()"
                  />
                </div>
              }
            </li>
          }
        </ol>
      } @else {
        <div class="input-submittals__empty">-</div>
      }
    </div>
    @if (canAdd() && !showMode()) {
      <div formRow>
        <div class="input-submittals__add">
          <procure-input-text
            class="input-submittals__text"
            label="Additional Item"
            [control]="customControl"
            (keypress)="onKeyPress($event)"
          />
          <button
            class="input-submittals__button"
            procure-button
            variant="stroked"
            [disabled]="!customControl.value || customControl.disabled"
            [matTooltip]="!customControl.value ? 'Please enter a value' : ''"
            (click)="addItem()"
          >
            Add Item
          </button>
        </div>
      </div>
    }
  </procure-expansion-panel>
</div>
